import { useCallback, useMemo, useState } from "react";

import TagsFilters, { defaultValues } from "./filter";
import TagListTable from "./table";
import { createData } from "./helper";
import TagsStyle from "./style";
import TagsHeader from "./header";

import { useTags } from "@/api/hooks/useTags";
import { TagsFilterBody } from "@/api/types/tag";

export default function TagListPage() {
    const [params, setParams] = useState<TagsFilterBody>({
        category: null,
        search: "",
        skip: 0,
        take: 5,
    });

    const { data: TagsListData, isError, error } = useTags(params);

    const tags = TagsListData?.data.items;
    const totalItems = TagsListData?.data.pagination.totalItems;
    const genreData = useMemo(() => (tags ? tags.map((item) => createData(item)) : []), [tags]);

    const handleChange = useCallback(({ page, rowsPerPage }: { page?: number, rowsPerPage?: number }) => {
        setParams((prev) => {
            return {
                ...prev,
                skip: Number(page) * Number(rowsPerPage),
                take: rowsPerPage,
            };
        });
    }, []);

    const handleFilterOnApply = useCallback((filterData: typeof defaultValues) => {
        setParams((prev) => {
            return {
                ...prev,
                search: String(filterData.search) || "",
                category: filterData.category || null,
            };
        });
    }, []);

    return (
        <TagsStyle>
            <TagsHeader />
            <TagsFilters onApply={handleFilterOnApply} />
            {isError && <p>{error.message}</p>}
            {tags && tags.length > 0 && (
                <TagListTable
                    data={genreData}
                    page={Number(params.skip) / Number(params.take)}
                    rowsPerPage={Number(params.take)}
                    totalItems={totalItems || 0}
                    onChange={handleChange}
                />
            )}
        </TagsStyle>
    );
}
